export * from './iconFontAwesomeWritingEnvelope';
export * from './iconFontAwesomeWritingPaperclip';
export * from './iconFontAwesomeWritingFile';
export * from './iconFontAwesomeWritingPen';
export * from './iconFontAwesomeWritingBook';
export * from './iconFontAwesomeWritingBookmark';
export * from './iconFontAwesomeWritingPenToSquare';
export * from './iconFontAwesomeWritingFolder';
export * from './iconFontAwesomeWritingFolderOpen';
export * from './iconFontAwesomeWritingThumbtack';
export * from './iconFontAwesomeWritingPaperPlane';
export * from './iconFontAwesomeWritingQuoteLeft';
export * from './iconFontAwesomeWritingPencil';
export * from './iconFontAwesomeWritingNewspaper';
export * from './iconFontAwesomeWritingQuoteRight';
export * from './iconFontAwesomeWritingBlog';
export * from './iconFontAwesomeWritingSignature';
export * from './iconFontAwesomeWritingKeyboard';
export * from './iconFontAwesomeWritingEraser';
export * from './iconFontAwesomeWritingSquarePen';
export * from './iconFontAwesomeWritingPenClip';
export * from './iconFontAwesomeWritingParagraph';
export * from './iconFontAwesomeWritingNoteSticky';
export * from './iconFontAwesomeWritingNotdef';
export * from './iconFontAwesomeWritingFileLines';
export * from './iconFontAwesomeWritingEnvelopeOpen';
export * from './iconFontAwesomeWritingBoxArchive';
export * from './iconFontAwesomeWritingBookBookmark';
